import TabOffer from '../EvaluationOperational/Offer';
import TabHPS from '../EvaluationOperational/HPS';
import TabAttendance from '../EvaluationOperational/Attendance';
import TabFreight from '../EvaluationOperational/Freight';
import TabRequirement from '../EvaluationOperational/Requirement';

export const MAIN_TABS = [
  {
    id: 'evaluation-operational',
    label: 'Evaluation Operational',
    icon: 'ri-settings-3-line',
  },
  {
    id: 'clarification',
    label: 'Clarification',
    icon: 'ri-chat-3-line',
    title: 'List of Offering',
  },
  {
    id: 'improvement',
    label: 'Improvement',
    icon: 'ri-arrow-up-circle-line',
    title: 'Improvement',
  },
];

export const DETAIL_TABS = [
  {
    id: 'Offer',
    label: 'Offer',
    icon: 'ri-price-tag-3-line',
    component: TabOffer,
  },
  {
    id: 'hps',
    label: 'HPS',
    icon: 'ri-calculator-line',
    component: TabHPS,
  },
  {
    id: 'attendance',
    label: 'Attendance Confirmation',
    icon: 'ri-user-follow-line',
    component: TabAttendance,
  },
  {
    id: 'freight',
    label: 'Freight Cost (for FOB)',
    icon: 'ri-ship-line',
    component: TabFreight,
  },
  {
    id: 'requirement',
    label: 'Requirement',
    icon: 'ri-shield-check-line',
    component: TabRequirement,
  },
];
